import React from "react";


const galleryImages = [
  { src: "/gallery1.JPG", alt: "Gallery photo 1" },
  { src: "/gallery2.jpeg", alt: "Gallery photo 2" },
  { src: "/gallery3.jpeg", alt: "Gallery photo 3" },
  { src: "/gallery4.JPG", alt: "Gallery photo 4" },
  { src: "/gallery7.JPG", alt: "Gallery photo 5" },
  { src: "/gallery6.jpeg", alt: "Gallery photo 6" },
];

function Gallery() {
  return (
    <div className="page">
      <section className="section section-light fade-up">
        <div className="section-inner">
          <h2>Photo Gallery</h2>
          <p className="section-intro">
            A few snapshots from our journey so far.
          </p>

          <div className="gallery-grid">
            {galleryImages.map((image, index) => (
              <div className="gallery-item" key={index}>
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Gallery;